import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

import {useIsAdminByRoles} from '@/modules/admin/hooks/useUser';

import jsonPackage from '../../../package.json';

const Footer = ({isCenter}) => {
  const isAdmin = useIsAdminByRoles();

  return (
    <div className={'bg-grey py-2 md:py-6'}>
      <div
        className={classNames('flex text-center md:text-left flex-col md:flex-row justify-center px-4 font-medium', {'pageViewport': isCenter})}>
        <div>
          © {moment().format('YYYY')} Ministerio de Economía y Planificación. Todos los derechos reservados.
          <span
            className={classNames('italic mx-2', {hidden: !isAdmin})}>v{jsonPackage?.version || '1.0.1'}</span>
        </div>
      </div>
    </div>
  );

};

Footer.propTypes = {
  isCenter: PropTypes.bool,
};

Footer.defaultProps = {
  isCenter: true
};

export default memo(Footer);
